import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted} from "vue";
import { store } from "@/store/store";
import router from "../../router";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const serialNo = ref("");
const workPattern = ref("");
const vinNo = ref("")

onMounted(function(){
  getTieData();
})

const getTieData = () => {
  vinNo.value = store.getters.vinNo;
  serialNo.value = store.getters.serialNo;
  workPattern.value = store.getters.workPattern;
}

const returnInitialPage = () => {
  router.push("/")
}

const __returned__ = { serialNo, workPattern, vinNo, getTieData, returnInitialPage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})